import type { CSSProperties } from "react";

/** A few big numbers, never a dashboard (`.k-mets`): two across, or three. */
export function Metrics({ items, three = false }: { items: ReadonlyArray<{ value: string; label: string }>; three?: boolean }) {
  return (
    <ul className={three ? "k-mets k-3" : "k-mets"}>
      {items.map((m) => (
        <li key={m.label} className="k-met">
          <b>{m.value}</b>
          <span>{m.label}</span>
        </li>
      ))}
    </ul>
  );
}

/** The funnel (`.k-fun`): each step a bar, in the order people go, as long as its share of `of`. */
export function Funnel({ steps, of, className }: { steps: ReadonlyArray<{ label: string; value: number; shown: string }>; of: number; className?: string }) {
  return (
    <ul className={className ? `k-fun ${className}` : "k-fun"}>
      {steps.map((s) => (
        <li key={s.label} style={{ "--f": `${of > 0 ? ((s.value / of) * 100).toFixed(1) : 0}%` } as CSSProperties}>
          <span>{s.label}</span>
          <b>{s.shown}</b>
          <i />
        </li>
      ))}
    </ul>
  );
}
